import { Target, CheckCircle2, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { GoalStats } from "../../types/goals";
import StatCard from "./StatCard";

const GoalsStats: React.FC<{ stats: GoalStats | null }> = ({ stats }) => {
    const { t } = useTranslation();

    // Provide default stats object
    const safeStats = stats || {
        completionRate: 0,
        completedTasks: 0,
        completedGoals: 0,
        onTrackGoals: 0,
        totalGoals: 0,
        averageProgress: 0,
        inProgressGoals: 0,
        upcomingMilestones: 0,
        pendingTasks: 0,
        taskCompletionRate: 0
    };


    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <StatCard
                title={t('goals.stats.averageProgress')}
                value={`${safeStats.averageProgress}%`}
                icon={<Target />}
            />
            <StatCard
                title={t('goals.stats.completedTasks')}
                value={`${safeStats.completedGoals}/${safeStats.totalGoals}`}
                icon={<CheckCircle2 />}
            />
            <StatCard
                title={t('goals.stats.inProgressGoals')}
                value={safeStats.inProgressGoals || '0'}
                icon={<Clock />}
            />
        </div>
    );
};

export default GoalsStats;